import * as actions from '../constants/AccountActionTypes';

export const setUserAccount = (payload) => ({ type: actions.SET_USER_ACCOUNT, payload });
export const updateUserAccount = (field, value) => ({ type: actions.UPDATE_USER_ACCOUNT, payload: { field, value } })
export const setLeadId = (payload) => ({ type: actions.SET_LEAD_ID, payload })